var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _path4, _path5, _path6, _rect6, _rect7, _rect8, _rect9, _rect10, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoldMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 80,
    viewBox: "0 0 49 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.44141,
    y: 36,
    width: 32.1176,
    height: 39.5735,
    fill: "#176BC6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.44141,
    y: 36,
    width: 32.1176,
    height: 39.5735,
    fill: "#176BC6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.6016,
    y: 36,
    width: 21.7941,
    height: 39.5735,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.6016,
    y: 36,
    width: 21.7941,
    height: 39.5735,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 17.6172,
    y: 36,
    width: 14.3382,
    height: 39.5735,
    fill: "#DB0D2A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 66.9688L41.3875 76.0018H7.6125L24.5 66.9688Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 49C38.031 49 49 38.031 49 24.5C49 10.969 38.031 0 24.5 0C10.969 0 0 10.969 0 24.5C0 38.031 10.969 49 24.5 49Z",
    fill: "#FBC21F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3.45104 27.3542C3.45104 14.0338 13.6792 3.21101 26.7617 2.25956C26.1671 2.25956 25.4535 2.14062 24.8588 2.14062C12.3709 2.14062 2.26172 12.2498 2.26172 24.8566C2.26172 28.5435 3.21317 32.1115 4.75929 35.2037C3.92677 32.7062 3.45104 30.0897 3.45104 27.3542Z",
    fill: "#89664C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M33.8994 43.4129C44.9601 36.0391 48.2902 21.6484 41.8678 10.4688L42.9382 11.8959C49.8363 22.1241 46.9819 36.0391 36.6348 43.0561C33.5426 45.1969 30.0936 46.3862 26.6445 46.743C29.261 46.0294 31.6397 44.959 33.8994 43.4129Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18.3164 17.1251V18.3144C19.5057 18.3144 20.5761 18.0766 21.6465 17.6008V15.9358C20.695 16.6494 19.6247 17.0062 18.3164 17.1251ZM26.1659 9.39453H27.2363V35.0838H26.1659V9.39453ZM30.6853 36.1542V39.4843H18.3164V40.6737H31.7557V36.1542H30.6853Z",
    fill: "#89664C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M27.2381 35.0839H30.5682V36.1543H27.2381V35.0839ZM22.8376 9.39461H26.1677V8.32422H21.6483C21.6483 10.8218 19.6265 12.8436 17.1289 12.8436V17.2441C17.4857 17.2441 17.8425 17.2441 18.1993 17.1252V13.7951C20.8158 13.914 22.8376 11.8922 22.8376 9.39461ZM22.8376 36.1543V17.1252C22.4808 17.3631 22.1241 17.482 21.7673 17.7199V35.0839H17.2478V39.4844H18.3182V36.1543H22.8376Z",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8.44141,
    y: 36,
    width: 32.1176,
    height: 39.5735,
    fill: "#176BC6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 8.44141,
    y: 36,
    width: 32.1176,
    height: 39.5735,
    fill: "#176BC6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 13.6016,
    y: 36,
    width: 21.7941,
    height: 39.5735,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 13.6016,
    y: 36,
    width: 21.7941,
    height: 39.5735,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 17.6172,
    y: 36,
    width: 14.3382,
    height: 39.5735,
    fill: "#DB0D2A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 66.9688L41.3875 76.0018H7.6125L24.5 66.9688Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 49C38.031 49 49 38.031 49 24.5C49 10.969 38.031 0 24.5 0C10.969 0 0 10.969 0 24.5C0 38.031 10.969 49 24.5 49Z",
    fill: "#FBC21F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3.45104 27.3542C3.45104 14.0338 13.6792 3.21101 26.7617 2.25956C26.1671 2.25956 25.4535 2.14062 24.8588 2.14062C12.3709 2.14062 2.26172 12.2498 2.26172 24.8566C2.26172 28.5435 3.21317 32.1115 4.75929 35.2037C3.92677 32.7062 3.45104 30.0897 3.45104 27.3542Z",
    fill: "#89664C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M33.8994 43.4129C44.9601 36.0391 48.2902 21.6484 41.8678 10.4688L42.9382 11.8959C49.8363 22.1241 46.9819 36.0391 36.6348 43.0561C33.5426 45.1969 30.0936 46.3862 26.6445 46.743C29.261 46.0294 31.6397 44.959 33.8994 43.4129Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18.3164 17.1251V18.3144C19.5057 18.3144 20.5761 18.0766 21.6465 17.6008V15.9358C20.695 16.6494 19.6247 17.0062 18.3164 17.1251ZM26.1659 9.39453H27.2363V35.0838H26.1659V9.39453ZM30.6853 36.1542V39.4843H18.3164V40.6737H31.7557V36.1542H30.6853Z",
    fill: "#89664C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M27.2381 35.0839H30.5682V36.1543H27.2381V35.0839ZM22.8376 9.39461H26.1677V8.32422H21.6483C21.6483 10.8218 19.6265 12.8436 17.1289 12.8436V17.2441C17.4857 17.2441 17.8425 17.2441 18.1993 17.1252V13.7951C20.8158 13.914 22.8376 11.8922 22.8376 9.39461ZM22.8376 36.1543V17.1252C22.4808 17.3631 22.1241 17.482 21.7673 17.7199V35.0839H17.2478V39.4844H18.3182V36.1543H22.8376Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldMedal);
export default __webpack_public_path__ + "static/media/goldMedal.c5bd6fcbd11fb818923118acf1e9e86e.svg";
export { ForwardRef as ReactComponent };